export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// ../~/d3-queue/src/array.js
// module id = NJtz
// module chunks = 0